import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadOption } from 'types';

const useRadioButtonLocales = (downloadOption: DownloadOption) => {
  const { t } = useTranslation();

  const { title, subtitle } = useMemo(() => {
    switch (downloadOption) {
      case DownloadOption.Mp3:
        return {
          title: t('songList:songFormats:mp3'),
          subtitle: t('songList:subtitle:mp3'),
        };
      case DownloadOption.Wav:
        return {
          title: t('songList:songFormats:wav'),
          subtitle: t('songList:subtitle:wav'),
        };
      case DownloadOption.Stems:
        return {
          title: t('songList:songFormats:stems'),
          subtitle: t('songList:subtitle:stems'),
        };
      case DownloadOption.SamplePack:
        return {
          title: t('songList:songFormats:samplePack'),
          subtitle: t('songList:subtitle:samplePack'),
        };
      default:
        return {
          title: t('songList:actions:downloadPDF'),
          subtitle: t('songList:subtitle:pdf'),
        };
    }
  }, [t, downloadOption]);

  return {
    title,
    subtitle,
  };
};

export default useRadioButtonLocales;
